var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.099 45.0205L26.8945 147.2H131.651L122.176 45.0205H36.099Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9883 55.0586V36.0683C56.9883 23.7246 66.9873 13.7256 79.331 13.7256C91.6747 13.7256 101.693 23.7246 101.693 36.0683V55.0586",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3652 121.879V118.507L76.2489 118.623V118.449L65.0098 128.448L76.2489 138.447V138.408L76.3652 138.524V135.153C95.7237 135.017 111.42 119.747 111.42 101.009C108.862 113.779 98.863 123.177 76.3652 121.918V121.879Z",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9027 90.8154L95.8991 92.5013L96.0541 92.54L95.8991 92.6369L110.471 97.0357L113.804 82.6379H113.766L113.804 82.5023L110.781 84.1882C100.976 68.0657 79.4667 62.543 62.666 71.922C75.3779 67.6782 88.8068 71.36 98.9221 90.8154H98.9027Z",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2317 87.4624L64.2353 89.1483L64.1966 88.9933L64.3516 89.0902L61.0186 74.6924L46.4464 79.0912H46.4852L46.3301 79.1687L49.3531 80.8546C39.7998 97.132 45.6325 117.905 62.4138 127.284C52.2598 118.758 48.8493 105.678 61.2124 87.4818L61.2317 87.4624Z",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.085 57.4994C52.085 54.8059 54.2747 52.6162 56.9876 52.6162C59.7005 52.6162 61.8708 54.8059 61.8708 57.4994C61.8708 60.193 59.6811 62.3827 56.9876 62.3827C54.294 62.3827 52.085 60.193 52.085 57.4994V57.4994Z",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.79 57.4994C96.79 54.8059 98.9797 52.6162 101.673 52.6162C104.367 52.6162 106.557 54.8059 106.557 57.4994C106.557 60.193 104.367 62.3827 101.673 62.3827C98.9797 62.3827 96.79 60.193 96.79 57.4994Z",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintBag);
export default __webpack_public_path__ + "static/media/footprint_bag.08f69a54b486f05b88025983d72fd999.svg";
export { ForwardRef as ReactComponent };